import { Modal } from "@mgdx/ui/components/Modal";

import {
  AgreementNewTermsConfirmView,
  AgreementNewTermsConfirmViewProps,
} from "../../views/AgreementNewTermsConfirmView";

export const AgreementNewTermsConfirmModal = ({
  isLoading,
  onClickAgreement,
  onClickShowReason,
}: AgreementNewTermsConfirmViewProps) => {
  return (
    <Modal open={true}>
      <AgreementNewTermsConfirmView
        isLoading={isLoading}
        onClickAgreement={onClickAgreement}
        onClickShowReason={onClickShowReason}
      />
    </Modal>
  );
};
